<template>
    <v-autocomplete
    v-model="localSelectedCode"
    :items="items"
    :search-input.sync="search"
    :filter="customFilter"
    item-text="name"
    item-value="code"
    placeholder="Search..."
    hide-details
    spellcheck="false"
    solo
    color="color1"
    :clearable="clearable">

    <template
    slot="selectionn"
    slot-scope="{ item }">
      <div style="display: flex;flex-wrap:nowrap;align-items:center;">
        <span class="blue-grey--text">
          {{ item.name }}
        </span>
      </div>
    </template>

    <template 
    slot="no-data">
      <v-list-item>
        <v-list-item-title>
          No matching
          <strong>languages</strong>
        </v-list-item-title>
      </v-list-item>
    </template>

    <template
    slot="item"
    slot-scope="{ item }">

    <v-list-item-avatar
    color="red lighten-2"
    class="headline font-weight-light white--text">
      {{ item.name.charAt(0) }}
    </v-list-item-avatar>
    <v-list-item-content>
      <v-list-item-title v-html="highlight(item.name)"></v-list-item-title>
      <v-list-item-subtitle v-text="item.code"></v-list-item-subtitle>
    </v-list-item-content>

    </template>

    </v-autocomplete>
</template>

<script>
export default {
  props: {
    selectedCode: null,
    clearable: false
  },
  data () {
    return {
      search: ''
    }
  },
  computed: {
    items () {
      return [{code: 'eng', name: 'English'}, {code: 'hrk', name: 'Croatian'}]
    },
    keywords () {
      return (this.search || '').toLowerCase().split(' ')
    },
    localSelectedCode: {
      get () {
        return this.selectedCode
      },
      set (nv) {
        this.$emit('update:selectedCode', nv)
        this.$emit('change', this.items.find(item => item.code === nv))
      }
    }
  },
  methods: {
    customFilter (item, queryText, itemText) {
      return this.keywords.every(keyword => {
        return (item.name + ' ' + item.code).toLowerCase().indexOf(keyword) > -1
      })
    },
    highlight (str) {
      var replacedStr = (this.search || '').trim().split(/\s+/).map(x => x.replace(/[-[\]{}()*+!<=:?.\\^$|#\s,]/g, '\\$&')).join('|')
      return str.replace(new RegExp(replacedStr, 'gi'), '<span class="font-weight-bold">$&</span>')
    }
  }
}
</script>

